import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { HP_COMPETITOR_ID } from '../constants'

import { getChangedItemWithUpdatedSellThruAndYoYFields } from './getChangedItemWithUpdatedSellThruAndYoYFields'

interface IGetRecalculatedSellThruAndFYFields {
  competitors: ISobCompetitor[]
  field: string
}

export const getRecalculatedSellThruAndFYFields = ({
  field,
  competitors,
}: IGetRecalculatedSellThruAndFYFields) => {
  return competitors.map((comp) => {
    const hpItem = competitors.find(
      (el) => el.EntryId === comp.EntryId && el.CompetitorID === HP_COMPETITOR_ID
    )
    const fieldValue = comp[field]

    return getChangedItemWithUpdatedSellThruAndYoYFields({
      field,
      value: fieldValue,
      item: comp,
      hpItem,
    })
  }, [])
}
